module.exports = __webpack_public_path__ + "static/img/10.44166b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene/10.jpg
// module id = ZO3v
// module chunks = 3